"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _LoyaltyTokenContainer = _interopRequireDefault(require("../../../components/LoyaltyToken/LoyaltyTokenContainer"));
require("./LoyaltyTokenLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('loyalty-token-layout');
var LoyaltyTokenLayout = function LoyaltyTokenLayout() {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses()
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: layoutClasses('header')
  }, t('Trading Fees')), /*#__PURE__*/_react["default"].createElement("p", {
    className: layoutClasses('description')
  }, t('Using the loyalty token for transaction fees applies a discount to your trading fee. If you hold the loyalty token in your account, you have the option of having your trading fees automatically subtracted from your loyalty token balance.')), /*#__PURE__*/_react["default"].createElement(_LoyaltyTokenContainer["default"], null));
};
var _default = exports["default"] = LoyaltyTokenLayout;